import styled from 'styled-components'

import { helpers } from 'styles'

export const Content = styled.div`
	padding: ${helpers.spacing.small} ${helpers.spacing.large} ${helpers.spacing.medium};
`
